module.exports = __webpack_public_path__ + "img/editLatex.23dedfdd.svg";